import React from "react";

export const GoogleDots = ({ className = "" }) => (
  <div className={`flex items-center gap-1.5 ${className}`} data-testid="google-loader">
    <span className="gdot" style={{ background: "#4A3BFA", animationDelay: "0s" }} />
    <span className="gdot" style={{ background: "#6C5CFF", animationDelay: "0.15s" }} />
    <span className="gdot" style={{ background: "#9C8FFF", animationDelay: "0.3s" }} />
    <span className="gdot" style={{ background: "#C9C1FF", animationDelay: "0.45s" }} />
  </div>
);

export const StepDots = ({ total, current }) => (
  <div className="flex items-center justify-center gap-2" data-testid="step-dots">
    {Array.from({ length: total }).map((_, i) => (
      <span
        key={i}
        className={`h-1.5 rounded-full transition-all duration-500 ${
          i === current ? "w-8 google-gradient" : i < current ? "w-2 bg-slate-400" : "w-2 bg-slate-200"
        }`}
      />
    ))}
  </div>
);
